module.exports = __webpack_public_path__ + "img/profile.42d7cf12.svg";